import { Injectable, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, CanDeactivate } from '@angular/router';

import { AuthGuard, AuthGuardFreemium, AuthGuardJail } from '../app/auth-guard';
import { FinancingComponent } from './financing.component';
import { HomeComponent } from './home.component';

const appRoutes: Routes = [
  {
    path: 'financing',
    canActivate: [AuthGuard, AuthGuardJail],
    component: FinancingComponent,
    children: [{ path: '', component: HomeComponent }],
  },
];

export const routing: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(appRoutes);
